import gql from "graphql-tag";

export const addOrderWhole = gql`mutation addOrderWhole($cartList: String) {
    addOrderWhole (
        cartList: $cartList
    ) {
        status
        errorMessage
        result{
            id
            userId
            currency
            orderItemsList{
                id
                categoryId
                subCategoryId
                orderId
                baseFare
                totalQuantity
                dropLocation
            }
        }
    }
  }`

export const getOrder = gql` query getOrder($promoId: Int,$isPromoIdRemove: Boolean){
  getOrder(promoId: $promoId ,isPromoIdRemove:$isPromoIdRemove){
    status
    errorMessage
    result{
     id
		 promoId
		 userId
		 status
		 userServiceFee
		 subTotal
		 total
		 isSpecialService
		 specialServiceFare
		 specialServiceTotalFare
     userPayableFare
		 currency
		 requestCurrency
		 travellingPrice
     reviewImage{
      imageName
     }
		 orderItemsList{
              id
		          categoryId
		          subCategoryId
		          orderId
		          baseFare
		          minimumHours
		          currency
		          totalQuantity
		          workedDuration
		          pausedDuration
		          startedAt
		          completedAt
              subCategoryBasePrice
              multiplierValue
              subCategoryDetails{
                id
                name
                description
                image
                categoryId
                status
                pricingDetails{
                  basePrice
                }
              }
            }
     categoryDetails{
                id
                name
                status
                description
                bannerImage
                pricingType
                isJobPhotoRequired
              }
    }
  }
}
  `

export const clearOrderedItems = gql`mutation clearOrderedItems($orderId: Int) {
    clearOrderedItems(orderId: $orderId) {
        status
        errorMessage
    }
}`

export const removeOrderItem = gql`mutation removeOrderItem($subCategoryId: Int, $orderId: Int,$isLastOrderItem:Boolean) {
  removeOrderItem (subCategoryId: $subCategoryId, orderId: $orderId,isLastOrderItem:$isLastOrderItem) {
      status
      errorMessage
      result{
          orderItemsList{
              id
          }
      }   
  }
}`

export const addOrder = gql`mutation addOrder(
        $categoryId: Int!
        $subCategoryId: Int!
        $totalQuantity: Int
        $currency: String!
        ) {
    addOrder (
        categoryId: $categoryId
        subCategoryId: $subCategoryId 
        totalQuantity: $totalQuantity 
        currency: $currency
    ) {
        status
        errorMessage
        result{
            id
            userId
            currency
            orderItemsList{
                id
                categoryId
                subCategoryId
                orderId
                baseFare
                totalQuantity
            }
        }
    }
  }`